module.exports = __webpack_public_path__ + "static/media/arrow-up.a6dce881.svg";